export enum QuickReportType {
    date = 'date',
    time = 'time',
    datetime = 'datetime',
    text = 'text',
    number = 'number',
    offsetFromToday = 'offsetFromToday',
    currentMonthStart = 'currentMonthStart',
    currentMonthEnd = 'currentMonthEnd'
}
